import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from './environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {

  private http = inject(HttpClient);

  private readonly prefix = '/assets/i18n/';
  private readonly suffix = '.json';
  private readonly version = environment.version;

  getTranslation(lang: string): Observable<Translation> {
    return this.http.get<Translation>(
      `${this.prefix}${lang}${this.suffix}?v=${this.version}`
    );
  }
}
